<template>
  <div class="home">
    <van-nav-bar title="自助平台" />
    <van-grid :column-num="3">
      <!-- <van-grid-item @click="gotoMyattend">
        <img src="../assets/pic15.png"
             alt="" /><span>考勤签卡</span>
      </van-grid-item> -->

      <!-- <van-grid-item @click="gotoProve">
        <img src="../assets/pic23.png"
             alt="" /><span>证明申请</span>
      </van-grid-item> -->
      <!-- <van-grid-item @click="gotoResume">
        <img src="../assets/pic14.png"
             alt="" /><span>我的简历</span>
      </van-grid-item> -->
      <!-- <van-grid-item @click="gotoSalary">
        <img src="../assets/pic16.png"
             alt="" /><span>我的薪资</span>
      </van-grid-item> -->
    </van-grid>
    <van-grid :column-num="3">
      <!-- <van-grid-item @click="gotoIncomeDetail">
        <img src="../assets/pic16.png" alt="" /><span>我的薪酬</span>
      </van-grid-item>
      <van-grid-item>
      </van-grid-item> -->
    </van-grid>
    <van-grid :column-num="3">
      <van-grid-item v-if="flag" @click="gotoMyteam">
        <img src="../assets/pic25.png" alt="" /><span>我的团队</span>
      </van-grid-item>
      <van-grid-item v-if="flag" @click="gotoMyteamAtt">
        <img src="../assets/pic26.png" alt="" /><span>团队考勤</span>
      </van-grid-item>
      <van-grid-item v-if="flag" @click="gotoMyteamPer">
        <img src="../assets/pic23.png" alt="" /><span>团队绩效</span>
      </van-grid-item>
      <van-grid-item v-if="flag" @click="gotoTeamanalysis">
        <img src="../assets/pic15.png" alt="" />
        <span>团队分析</span>
      </van-grid-item>
      <van-grid-item v-if="flag" @click="gotoTeamrp">
        <img src="../assets/obj.png" alt="" />
        <span>奖惩信息</span>
      </van-grid-item>
      <van-grid-item v-if="firstLevel === 'Y'" @click="gotoTeampay">
        <img src="../assets/pic16.png" alt="" />
        <span>团队薪酬</span>
      </van-grid-item>
      <!-- <van-grid-item v-if="firstLevel === 'Y'"
                     @click="gotoSalaryChange">
        <img src="../assets/obj(7).png"
             alt="" />
        <span>团队调薪</span>
      </van-grid-item> -->
    </van-grid>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { getBasicMsgDataApi } from '../request/api';

  export default {
    name: 'Home',
    data() {
      return {
        currentTime: '',
        flag: false,
        firstLevel: ''
      };
    },
    components: {},
    methods: {
      gotoResume() {
        this.$router.push('/resume');
      },
      gotoSalary() {
        this.$router.push('/login');
      },
      gotoMyteam() {
        this.$router.push('/myteam');
      },
      gotoProve() {
        this.$router.push('/prove');
      },
      // gotoIncomeDetail() {
      //   this.$router.push('/login')
      // },

      gotoMyattend() {
        this.$router.push('/myattend');
      },
      gotoHrWork() {
        this.$router.push('/hrwork');
      },
      //团队绩效
      gotoMyteamPer() {
        this.$router.push('/teamperformance');
      },

      gotoMyteamAtt() {
        this.$router.push('/myteamatt');
      },
      //团队分析
      gotoTeamanalysis() {
        this.$router.push('/teamanalysis');
      },
      //团队奖惩信息
      gotoTeamrp() {
        this.$router.push('/teamrp');
      },
      //团队薪酬
      gotoTeampay() {
        this.$router.push('/teampay');
      },
      //团队调薪
      gotoSalaryChange() {
        this.$router.push('/teamsalarychange');
      }
    },
    created() {
      var s = new Date();
      var m = s.getMonth() + 1;
      var d = s.getDate();
      if (m >= 1 && m <= 9) {
        m = '0' + m;
      }
      if (d >= 0 && d <= 9) {
        d = '0' + d;
      }
      this.currentTime = s.getFullYear() + '-' + m + '-' + d;
      let params = {
        EMPLID: sessionStorage.getItem('EMPLID')
      };
      getBasicMsgDataApi(params).then(res => {
        if (res.CODE == 200) {
          this.firstLevel = res.DATA.C_LEADER_FLAG;

          if (res.DATA.C_DEPT_FLAG == 'Y' || res.DATA.C_LEADER_FLAG == 'Y') {
            this.flag = true;
          }
        }
      });
    }
  };
</script>
<style lang="less" scoped>
  /deep/ .van-nav-bar {
    background: #5076b7;
  }
  /deep/ .van-nav-bar__left i {
    color: white;
  }

  /deep/.van-nav-bar__text,
  /deep/.van-nav-bar__title {
    color: white;
    font-size: 15px;
  }
  /deep/ .van-grid {
    margin: 9px;
    border-radius: 9px;
    overflow: hidden;
  }
  img {
    width: 30px;
    height: 30px;
  }
  span {
    font-size: 13px;
    margin-top: 10px;
  }
</style>
